'use client'

import cn from 'classnames'
import Link from 'next/link'
import styles from './Button.module.scss'

function noop() {
  return
}

export function Button({
  prepend = null,
  append = null,
  fullWidth = false,
  href,
  type,
  size = 'small',
  disabled = false,
  uppercase = true,
  onClick = noop,
  style = 'primary',
  className = '',
  linkClass = '',
  radius = 5,
  scroll = true,
  children
}) {

  const maybeWithLink = (children) => {
    if (href) {
      return (
        <Link href={href} style={{borderRadius: radius ? radius + 'px' : undefined}} className={`${styles.button_link} ${styles.button_pad}`} scroll={scroll} passHref>
          <a className={`${buttonClasess} ${className} ${linkClass} flex items-center`}>
            {prepend}
            {children}
            {append}
          </a>
        </Link>
      )
    }
    return (
      <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={`${buttonClasess} ${className}`}
        style={{borderRadius: radius ? radius + 'px' : undefined}}
      >
        {prepend}
        {children}
        {append}
      </button>
    )
  }

  const buttonClasess = cn({
    [styles.button]: true,
    [styles.button_pad]: !href,
    [styles['button_' + size]]: true,
    [styles['button_' + style]]: true,
    [styles['button_uppercase']]: uppercase,
    [styles.button_disabled]: disabled,
    ['w-full']: fullWidth
  })

  return (
    maybeWithLink(children)
  )
}
